import React, { useEffect, useRef } from 'react';
import styles from './newsletter.module.css';

export default function Newsletter() {
  const formRef = useRef(null);

  useEffect(() => {
    if (!formRef.current) return;

    const formDiv = document.createElement('div');
    formDiv.className = 'ctct-inline-form';
    formDiv.setAttribute('data-form-id', 'c776c435-1efb-447d-b174-f20cc77203e1');
    formRef.current.appendChild(formDiv);

    const initWidget = () => {
      document.dispatchEvent(new Event('DOMContentLoaded', { bubbles: true }));
      window.dispatchEvent(new Event('load'));
      if (window.ctctSignupForm) {
        window.ctctSignupForm.init();
      }
    };

    const loadScript = () => {
      window._ctct_m = '0432783ed4d40930d0d2824f67f11e42';
      const script = document.createElement('script');
      script.id = 'signupScript';
      script.src = '//static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js';
      script.async = true;
      script.defer = true;
      script.onload = initWidget;
      script.onerror = (e) => console.error('[CTCT] signup widget failed to load', e);
      document.body.appendChild(script);
    };

    let retryTimer;
    if (document.getElementById('signupScript')) {
      // The widget only scans the DOM for .ctct-inline-form when its script
      // executes, so if the script was already loaded by the popup loader on a
      // previous page it won't see this div. Try nudging it first; if the form
      // still hasn't rendered, remove and re-inject the script to force a
      // fresh scan.
      initWidget();
      retryTimer = setTimeout(() => {
        if (!formDiv.hasChildNodes()) {
          document.getElementById('signupScript').remove();
          loadScript();
        }
      }, 2000);
    } else {
      loadScript();
    }

    return () => {
      clearTimeout(retryTimer);
      formDiv.remove();
    };
  }, []);

  return (
    <div className={styles.newsletterContainer}>
      <h1>Subscribe to Our Newsletter</h1>
      <p>Stay updated with the latest in integrative oncology research and resources.</p>

      <div className={styles.formContainer} ref={formRef}>
        {/* Constant Contact form will be injected here by useEffect */}
      </div>
    </div>
  );
}
